import React from "react";
import Links from "./Links";
import { Nav, Navbar } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from "react-bootstrap";

function Footer({ currentPage, handlePageChange }) {
  return (
    <footer className="footer text-center" style={{ width: "100%", }}>
      <div className="align-items-center">
        {/* <FTabs currentPage={currentPage} handlePageChange={handlePageChange} /> */}
            <div className="d-flex justify-content-center">
              <Nav className="mr-auto align-items-center">
               <Navbar.Brand as={Link} to="/" onClick={() => handlePageChange('Home')} className="brand-link" style={{ flex: '0 0 auto', zIndex: '1'   }}>
                  <h8>
                  2nd Team Productions
                </h8>
                </Navbar.Brand>
            </Nav>
            </div>
            <div  
            style={{ 
            width: "100%", 
            position: 'relative', 
            backgroundSize: '25% auto', 
            backgroundPosition: 'center', 
            backgroundRepeat: 'no-repeat',}}>
          <div className="d-flex mr-auto  justify-content-center"
            style={{ width: "100%", 
            marginBottom:'2.5vmin',
            marginTop:'1.5vmin',
            }}>
            <Links currentPage={currentPage} handlePageChange={handlePageChange} />
            </div>

            <div className="d-flex justify-content-center">
              <Nav className="justify-content-center brand-link">
                <Navbar.Brand as={Link} to="/Privacy" onClick={() => handlePageChange('Home')} className="brand-link" style={{ flex: '0 0 auto' }}>
                  <h8>Privacy & Terms of Service</h8>
                </Navbar.Brand>
              </Nav>
            </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
